import { render, staticRenderFns } from "./CustomerProfileForm.vue?vue&type=template&id=073b140f&"
import script from "./CustomerProfileForm.vue?vue&type=script&lang=ts&"
export * from "./CustomerProfileForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports